/** Loading / load-failed state shared by the Connected Health screens. */
function LoadState({ status, onRetry, errorText }) {
  if (status === "loading") {
    return (
      <p className="ch-state" role="status">
        Loading your connected health…
      </p>
    );
  }
  return (
    <div className="ch-state" role="alert">
      <p>{errorText || "We couldn't load your connected health. Please try again."}</p>
      <button type="button" className="ch-btn ch-btn--secondary" onClick={onRetry}>
        Try again
      </button>
    </div>
  );
}

export default LoadState;
